const initialState = {
    searchInbox:"",
    serchOutbox:""
    

};

const delectionSearchReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case "Delection_Search_Inbox":
            return {
                ...state,
                searchInbox: payload,
            };
            case "Delection_Search_Outbox":
            return {
                ...state,
                serchOutbox:payload,
            };
        default:
            return state;
    }
};

export default delectionSearchReducer;
